<script>
import { IconCircleXmark } from "@/components/icons/index";

export default {
  name: "AppButtonClear",

  components: {
    IconCircleXmark,
  },
};
</script>

<template>
  <button
    v-on="$listeners"
    class="btn-clear d-flex align-items-center cursor-pointer py-1 px-2 gap-1"
  >
    <IconCircleXmark size="13px" color-fill="#74788D" />
    <span class="text-gray-dark">Clear All</span>
  </button>
</template>

<style lang="scss" scoped>
.btn-clear {
  border-radius: 9999px;
  border-width: 0;

  &:hover {
    background: #f5f6f8;

    span {
      color: #d6001b !important;
    }

    path {
      stroke: #d6001b;
      fill: #d6001b;
    }
  }
}
</style>
